export default __webpack_public_path__ + "static/media/logo.cfb86179.jpg";